var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('div',{attrs:{"id":"container"}}),_c('div',{staticClass:"mt-10"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"tips"},[_c('div',{staticClass:"tip"},[_vm._v("主讲人："+_vm._s(_vm.teacherName))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }